import React, {useState} from 'react';
import Carousel from '../Carousel';
import ListProduct from '../ListProduct';
import {flatProducts} from './helpers';

import styles from './styles.module.css';

const CarouselProducts = ({categories, current, limit = 5}) => {
  const [products, setProducts] = useState(null);
  // useEffect(() => {
  const randomProducts = () => {
    setProducts(flatProducts(categories, current, limit));
  };
  if (categories && !products) {
    randomProducts();
  }
  // }, [categories, products, limit, current]);
  if (!products) return null;
  return (
    <div className={styles.carousel_container}>
      <h2 className={styles.title}>
        Autres produits qui pourraient vous intéresser
      </h2>
      <Carousel showDot={true} step={6}>
        {products.map(e => (
          <div key={e.id} className={styles.product}>
            <ListProduct product={e} shadow={false} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CarouselProducts;
